export const SET_ACTIVE_LIST_TAB = 'SET_ACTIVE_LIST_TAB';
export const setActiveListTab = (tab: string) => ({
  type: SET_ACTIVE_LIST_TAB,
  payload: tab,
});

interface IListPageProps {
  activeListTab: string;
}

const initialState: IListPageProps = {
  activeListTab: 'contacts',
};
const setTPListPageReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_ACTIVE_LIST_TAB:
      return { ...state, activeListTab: action.payload };
    default:
      return state;
  }
};

export default setTPListPageReducer;
